import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useRole from "./components/useRole";
import { getEventVoucherStats } from "../../api/vouchers";

const VoucherStatsComponent = ({ eventId }) => {
  const { isAdmin } = useRole();
  const [stats, setStats] = useState({
    totalVouchers: 0,
    activeVouchers: 0,
    totalUsage: 0,
    totalDiscount: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVoucherStats = async () => {
      try {
        setLoading(true);
        const response = await getEventVoucherStats(eventId);
        const statsData = response?.data?.data || {};

        setStats({
          totalVouchers: statsData.totalVouchers || 0,
          activeVouchers: statsData.activeVouchers || 0,
          totalUsage: statsData.totalUsage || 0,
          totalDiscount: statsData.totalDiscount || 0
        });
      } catch (error) {
        console.error("Error fetching voucher stats:", error);
        // Set default values on error
        setStats({
          totalVouchers: 0,
          activeVouchers: 0,
          totalUsage: 0,
          totalDiscount: 0
        });
      } finally {
        setLoading(false);
      }
    };

    fetchVoucherStats();
  }, [eventId]);

  if (loading) {
    return (
      <div className="bg-white p-6 rounded-xl shadow">
        <h2 className="text-lg font-semibold mb-4">🎫 Voucher Statistika</h2>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">🎫 Voucher Statistika</h2>
        {isAdmin && (
          <Link
            to={`/dashboard/${eventId}/vouchers`}
            className="text-blue-600 hover:text-blue-700 text-sm font-medium"
          >
            Hamısını gör →
          </Link>
        )}
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">
            {stats.totalVouchers}
          </div>
          <div className="text-sm text-gray-600">Ümumi Voucher</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600">
            {stats.activeVouchers}
          </div>
          <div className="text-sm text-gray-600">Aktiv Voucher</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-purple-600">
            {stats.totalUsage}
          </div>
          <div className="text-sm text-gray-600">Ümumi İstifadə</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-orange-600">
            {stats.totalDiscount}₼
          </div>
          <div className="text-sm text-gray-600">Ümumi Endirim</div>
        </div>
      </div>
      
      {isAdmin && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <Link
            to={`/dashboard/${eventId}/vouchers/new`}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg text-center block transition-colors"
          >
            ➕ Yeni Voucher Yarat
          </Link>
        </div>
      )}
    </div>
  );
};

export default VoucherStatsComponent;
